import React, { useEffect, useState } from 'react';
import Box from '@material-ui/core/Box';
import GridContainer from '../../../../@jumbo/components/GridContainer';
import Grid from '@material-ui/core/Grid';
import AppTextInput from '../../../../@jumbo/components/Common/formElements/AppTextInput';
import Button from '@material-ui/core/Button';
import AppSelectBox from '../../../../@jumbo/components/Common/formElements/AppSelectBox';
import { useDispatch, useSelector } from 'react-redux';
import { clearCurrentDownloadItem, createDownloadItem, updateDownloadItem } from 'redux/actions/Movies';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import { Checkbox, FormControlLabel, InputAdornment } from '@material-ui/core';

const qualities = [
  { quality: '360p', qualityId: '_360p' || 0 },
  { quality: '480p', qualityId: '_480p' || 1 },
  { quality: '720p', qualityId: '_720p' || 2 },
  { quality: '1080', qualityId: '_1080p' || 3 },
  { quality: '1080hq', qualityId: '_1080hq' || 4 },
  { quality: 'blueray', qualityId: '_bluray' || 5 },
  { quality: 'all', qualityId: '_all' || 6 },
  { quality: '576p', qualityId: '_576p' || 7 },
  { quality: 'hls', qualityId: '_hls' || 8 },
];

const CreateMovieFrom = () => {
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const downloadId = params.get('p') === 'null' ? localStorage.getItem('downloadId') : params.get('p');
  const id = params.get('ui');
  const downloadType = params.get('type');
  const movieName = params.get('name');
  const downloadUID = params.get('downloadUID');

  const pathToBack = `/create-download/?ui=${downloadUID}&download=${downloadId}&type=${downloadType}&name=${movieName}`

  const { downloadItem } = useSelector(({ movies }) => movies);
  const dispatch = useDispatch();
  const [cost, setCost] = useState(downloadItem?.cost || 0);
  const [quality, setQuality] = useState(downloadItem?.quality || '');
  const [discountPrice, setDiscountPrice] = useState(downloadItem?.discount_price || null);
  const [fileSize, setFileSize] = useState(downloadItem?.filesize || '');
  const [staticLink, setStaticLink] = useState(downloadItem?.static_url || '');
  const [shortLink, setShortLink] = useState(downloadItem?.short_link || '');
  const [mirrorStaticLink, setMirrorStaticLink] = useState(downloadItem?.mirror_static_url || '');
  const [mirrorShortLink, setMirrorShortLink] = useState(downloadItem?.mirror_short_link || '');
  const [allowTaptureLink, setAllowTaptureLink] = useState(downloadItem?.allow_tapture_link || false);
  const [subtitled, setSubtitled] = useState(downloadItem?.subtitle || false);
  const [dubbed, setDubbed] = useState(downloadItem?.dubbed || false);

  const calcDiscountPercentage = (orginalPrice, discountPrice) => {
    const percentage = ((orginalPrice - discountPrice) / orginalPrice) * 100;
    return orginalPrice > 0 ? Math.round(percentage) || 0 : 0;
  };

  const handleSubmit = () => {
    const data = {
      download_id: downloadItem?.id,
      quality: quality,
      cost: cost,
      discount_price: discountPrice,
      static_url: staticLink,
      filesize: fileSize,
      short_link: shortLink,
      mirror_static_url: mirrorStaticLink,
      mirror_short_link: mirrorShortLink,
      allow_tapture_link: allowTaptureLink,
      subtitle: subtitled,
      dubbed: dubbed,
    };
    if (downloadItem === null) {
      dispatch(createDownloadItem({ data, id, downloadId, downloadType }, history, pathToBack));
    } else {
      dispatch(updateDownloadItem({ data, id: downloadItem?.id, downloadId }));
    }
  };

  useEffect(() => {
    return () => {
      if (history.action === 'POP') {
        dispatch(clearCurrentDownloadItem());
      }
    };
  }, [dispatch, history]);

  return (
    <React.Fragment>
      <GridContainer>
        <Grid item xs={12} sm={6}>
          <AppSelectBox
            fullWidth
            data={qualities}
            label="کیفیت"
            value={quality}
            onChange={e => setQuality(e.target.value)}
            valueKey="qualityId"
            variant="outlined"
            labelKey="quality"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <AppTextInput
            fullWidth
            variant="outlined"
            label="قیمت"
            value={cost}
            onChange={e => {
              setCost(e.target.value);
            }}
          />
        </Grid>
      </GridContainer>
      <GridContainer style={{ marginBottom: 12 }}>
        <Grid item xs={12} sm={6}>
          <AppTextInput
            fullWidth
            variant="outlined"
            label="قیمت بعد از تخفیف"
            value={discountPrice}
            onChange={e => {
              setDiscountPrice(e.target.value);
            }}
            InputProps={{
              endAdornment: <InputAdornment position="start">%{calcDiscountPercentage(cost, discountPrice)}</InputAdornment>,
            }}
          />
        </Grid>
      </GridContainer>
      {downloadType !== 'bundle' ? (
        <>
          <GridContainer style={{ marginBottom: 12 }}>
            <Grid item xs={12} sm={6}>
              <AppTextInput
                fullWidth
                variant="outlined"
                label="لینک ثابت"
                value={staticLink}
                onChange={e => {
                  setStaticLink(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <AppTextInput
                fullWidth
                variant="outlined"
                label="لینک کوتاه"
                value={shortLink}
                onChange={e => {
                  setShortLink(e.target.value);
                }}
              />
            </Grid>
          </GridContainer>
          <GridContainer style={{ marginBottom: 12 }}>
            <Grid item xs={12} sm={6}>
              <AppTextInput
                fullWidth
                variant="outlined"
                label="لینک ثابت-کمکی"
                value={mirrorStaticLink}
                onChange={e => {
                  setMirrorStaticLink(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <AppTextInput
                fullWidth
                variant="outlined"
                label="لینک کوتاه-کمکی"
                value={mirrorShortLink}
                onChange={e => {
                  setMirrorShortLink(e.target.value);
                }}
              />
            </Grid>
          </GridContainer>
          <GridContainer style={{ marginBottom: 12 }}>
            <Grid item xs={12} sm={6}>
              <AppTextInput
                fullWidth
                variant="outlined"
                label="اندازه فایل"
                value={fileSize}
                onChange={e => {
                  setFileSize(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={subtitled}
                    inputProps={{ 'aria-label': 'controlled' }}
                    onChange={event => setSubtitled(event.target.checked)}
                  />
                }
                label="زیرنویس فارسی"
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={dubbed}
                    inputProps={{ 'aria-label': 'controlled' }}
                    onChange={event => setDubbed(event.target.checked)}
                  />
                }
                label="دوبله فارسی"
              />
            </Grid>
          </GridContainer>
          <GridContainer>
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={allowTaptureLink}
                    inputProps={{ 'aria-label': 'controlled' }}
                    onChange={event => setAllowTaptureLink(event.target.checked)}
                  />
                }
                label="مجوز فروش ترافیک"
              />
            </Grid>
          </GridContainer>
        </>
      ) : null}
      <Box display="flex" justifyContent="flex-end" mb={4}>
        <Button onClick={() => history.push(pathToBack)}>{downloadItem === null ? 'لغو' : 'بازگشت'}</Button>
        <Box ml={2}>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            ثبت اطلاعات
          </Button>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default CreateMovieFrom;

CreateMovieFrom.prototype = {
  selectedContact: PropTypes.object,
};

CreateMovieFrom.defaultProps = {
  selectedContact: null,
};
